module.exports = __webpack_public_path__ + "images/main_man.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_man.png
// module id = 1125
// module chunks = 0